export default __webpack_public_path__ + "static/media/court-4.ca64d6db.png";